import React from 'react';
import close from "../../../assets/Icons/close.png";
import error from "../../../assets/svg/failed.svg";
import "../signal.css";

const FailedError = ({ onClose }) => {
    return (
        <div className="h-full bg bg-transparent w-full flex justify-center items-center">
            <div className="bg-white w-11/12 max-w-md flex flex-col items-center p-6 rounded-lg shadow-xl">
                <div className="text-end w-full">
                    <button
                        type="button"
                        onClick={onClose}
                    >
                        <img src={close} alt="close_img" width="26px" />
                    </button>
                </div>
                <img src={error} alt="error" className="w-32 h-32" />
                <p className="text-center my-5 font-medium text-signal-ai-blue">
                    Aiမှစစ်ဆေးမှုပြုလုပ်ရန်ခက်ခဲနေပါသည်။ <br /> ပြန်လည်ကြိုးစားပါ။
                </p>
                <button
                    type="button"
                    className="bg-signal-ai-secondary text-white w-full h-11 font-semibold text-base shadow-2xl rounded-lg"
                    onClick={onClose}
                >
                    နောက်သို့
                </button>
            </div>
        </div>
    );
};

export default FailedError;
